import * as Yup from 'yup';

export const validate = Yup.object().shape({
    botones: Yup.object().shape({
        nombre: Yup.string().required('Campo Obligatorio'),
        url: Yup.string().required('Campo Obligatorio'),
        estilo: Yup.string().required('Campo Obligatorio')
    })
});
    